import './OrderDetail.scss';
import Component from './OrderDetail.js';
export default Component;
